class FacFeaturesAccordion {
  constructor(element) {
    this.element = element;
    this.accordions = this.element.querySelectorAll('[data-accordion]');
    this.list = this.element.querySelector('.fac-features-accordion__list');
    this.background = this.element.querySelector('.fac-features-accordion__background');
    this.init();
    this.initScrollAnimation();
  }

  init() {
    // ページロード時に各コンテンツの高さを計算してCSS変数として設定
    this.accordions.forEach((accordion) => {
      const contentWrapper = accordion.querySelector('.fac-accordion__content-wrapper');
      const content = accordion.querySelector('.fac-accordion__content');

      if (contentWrapper && content) {
        const height = content.scrollHeight;
        contentWrapper.style.setProperty('--max-height', height + 'px');
      }

      const summary = accordion.querySelector('.fac-accordion__summary');

      // 初期状態でopen属性がある場合、is-openクラスを追加
      if (accordion.hasAttribute('open')) {
        accordion.classList.add('is-open');
        if (contentWrapper) {
          contentWrapper.classList.add('is-open');
        }
      }

      // クリックイベントでデフォルト動作を防ぐ
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAccordion(accordion);
      });

      // toggleイベントでもデフォルト動作を防ぐ
      accordion.addEventListener('toggle', (e) => {
        e.preventDefault();
      });
    });

    // 初期状態をチェック
    this.checkAllClosed();
  }

  initScrollAnimation() {
    if (!this.list || !this.background || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.fromTo(
      this.background,
      {
        filter: 'blur(0px)',
      },
      {
        filter: 'blur(10px)',
        ease: 'none',
        scrollTrigger: {
          trigger: this.list,
          start: 'top bottom',
          end: 'top 60%',
          scrub: true,
          //markers: true,
        },
      }
    );

    // ページの高さが変更された時にScrollTriggerをリフレッシュ
    this.setupResizeObserver();
  }

  setupResizeObserver() {
    if (typeof ResizeObserver === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      ScrollTrigger.refresh();
      // リサイズ時に高さを再計算
      this.recalculateHeights();
    });

    // body要素を監視
    resizeObserver.observe(document.body);

    // アコーディオンのコンテンツも監視(開閉時に高さが変わる)
    this.accordions.forEach((accordion) => {
      resizeObserver.observe(accordion);
    });
  }

  recalculateHeights() {
    this.accordions.forEach((accordion) => {
      const contentWrapper = accordion.querySelector('.fac-accordion__content-wrapper');
      const content = accordion.querySelector('.fac-accordion__content');

      if (contentWrapper && content) {
        const height = content.scrollHeight;
        contentWrapper.style.setProperty('--max-height', height + 'px');
      }
    });
  }

  toggleAccordion(accordion) {
    const isOpen = accordion.classList.contains('is-open');

    if (isOpen) {
      this.closeAccordion(accordion);
    } else {
      this.openAccordion(accordion);
    }

    // 全てのアコーディオンの状態をチェック
    this.checkAllClosed();
  }

  checkAllClosed() {
    if (!this.list) {
      console.warn('fac-features-accordion__list element not found');
      return;
    }

    const allClosed = Array.from(this.accordions).every((accordion) => !accordion.classList.contains('is-open'));

    if (allClosed) {
      this.list.classList.add('all-closed');
    } else {
      this.list.classList.remove('all-closed');
    }
  }

  openAccordion(accordion) {
    const contentWrapper = accordion.querySelector('.fac-accordion__content-wrapper');

    // アコーディオンを開く(open属性とis-openクラスを追加)
    accordion.setAttribute('open', '');
    accordion.classList.add('is-open');

    if (contentWrapper) {
      contentWrapper.classList.add('is-open');
    }
  }

  closeAccordion(accordion) {
    const contentWrapper = accordion.querySelector('.fac-accordion__content-wrapper');

    // is-openクラスを削除(アニメーション開始)
    accordion.classList.remove('is-open');

    if (contentWrapper) {
      contentWrapper.classList.remove('is-open');
    }

    // アニメーション完了後にopen属性を削除
    setTimeout(() => {
      accordion.removeAttribute('open');
    }, 400); // CSSのtransition時間と合わせる(g.$duration-base = 0.4s)
  }
}

// DOMContentLoaded時に初期化
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.fac-features-accordion').forEach((element) => {
      new FacFeaturesAccordion(element);
    });
  });
} else {
  document.querySelectorAll('.fac-features-accordion').forEach((element) => {
    new FacFeaturesAccordion(element);
  });
}
